<template>
  <BaseModal modal-content-class="resub">
    <div class="content">
      <h1>{{ $_translations.value.modal_resubscribe_via_web_title }}</h1>

      <BaseImage
        src="/static/images/modals/resubscribe/resubscribe_icon.svg"
        alt="Resubscribe"
        image-class="top_img"
      />

      <h2>{{ $_translations.value.modal_resubscribe_via_web_subtitle }}</h2>

      <p>{{ $_translations.value.modal_resubscribe_via_web_description }}</p>

      <BaseButton
        container-class="resub_btn"
        :disabled="submitting"
        @click:button="handleProceed"
      >
        {{ $_translations.value.modal_resubscribe_via_web_button_proceed }}
      </BaseButton>

      <ResubscribeTermsSection />
    </div>
  </BaseModal>
</template>

<script setup>
import { ref } from 'vue';
import BaseModal from '@/components/modal/BaseModal.vue';
import BaseImage from '@/components/image/BaseImage.vue';
import BaseButton from '@/components/button/BaseButton.vue';
import ResubscribeTermsSection from '@/components/subscription/section/ResubscribeTermsSection.vue';
import useAppSettingsStore from '@/store/modules/appSettings.js';
import useAuthStore from '@/store/modules/auth.js';
import useIntegrationStore from '@/store/modules/integration.js';

const emits = defineEmits(['resubscribe:viaWeb']);

const appSettingsStore = useAppSettingsStore();
const authStore = useAuthStore();
const integrationStore = useIntegrationStore();

const submitting = ref(false);

const handleProceed = async () => {
  try {
    submitting.value = true;
    console.log('1');
    await integrationStore.dispatchIntegrationResubscribeViaWebReoptin();
    console.log('2');
    await authStore.dispatchRetrieveAuthUser();
    console.log('3');
    if (appSettingsStore.appProperties.isReoptinOneStep && authStore.user.subscribed) {
      emits('resubscribe:viaWeb', { status: 'success' });
      console.log('3.1');
    } else if (!appSettingsStore.appProperties.isReoptinOneStep && !authStore.user.subscribed) {
      emits('resubscribe:viaWeb', { status: 'pinRequired' });
      console.log('3.2');
    } else {
      emits('resubscribe:viaWeb', { status: 'error' });
      console.log('3.3');
    }
  } catch {
    emits('resubscribe:viaWeb', { status: 'error' });
    console.log('4');
  } finally {
    submitting.value = false;
  }
};
</script>
